import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import RangeSlider from '../RangeSlider';
import SuggestedAgents from './SuggestedAgents';
import './ClientCheckInSurvey.scss';

export default class ClientCheckInSurvey extends Component {
    static get propTypes() {
        return {
            requestId: PropTypes.number,
            isBuyer: PropTypes.bool,
            surveyType: PropTypes.oneOf(['AFTER_CALL', 'AFTER_INTERVIEW']),
            agents: PropTypes.array,
            assignedAdmin: PropTypes.object
        };
    }

    state = {
        checkedAgents: {},
        concerns: {},
        score: 10,
        isLoadingSuggestedAgents: false,
        loadedSuggestedAgents: false,
        suggestedRealtors: [],
        suggestedRealtorQuotes: [],
        suggestedRealtorEndorsements: []
    };

    get isFormValid() {
        const {surveyType} = this.props;
        const {score, checkedAgents, upNestImprove} = this.state;
        const selectedAnyAgentOption = Object.entries(checkedAgents).filter(([, isChecked]) => isChecked).length > 0;
        return +score > 0
            && !(surveyType == 'AFTER_CALL' && isBlank(upNestImprove))
            && !(surveyType == 'AFTER_CALL' && !selectedAnyAgentOption);
    }

    setAgentChecked(agent, isCheckedOptional) {
        const {checkedAgents, concerns} = this.state;
        const isChecked = typeof isChecked != 'undefined' ? isCheckedOptional : !checkedAgents[agent.realtorId];
        if (agent.isNone) {
            this.setState({
                checkedAgents: {
                    0: isChecked
                },
                concerns: {},
            });
        } else {
            this.setState({
                checkedAgents: {
                    ...checkedAgents,
                    0: false,
                    [agent.realtorId]: isChecked
                },
                concerns: {
                    ...concerns,
                    [agent.realtorId]: null
                }
            });
        }
    }

    setConcern(agent, value) {
        const {concerns} = this.state;
        this.setState({
            concerns: {
                ...concerns,
                [agent.realtorId]: value
            }
        });
    }

    setScore(score) {
        this.setState({score});
    }

    submit() {
        const {score, comment, checkedAgents, concerns, upNestImprove, upNestFeedback} = this.state;

        const params = [
            {name: 'requestId', value: this.props.requestId},
            {name: 'buyer', value: this.props.isBuyer},
            {name: 'surveyType', value: this.props.surveyType}
        ];
        if (score) {
            params.push({name: 'score', value: score});
        }
        if (comment) {
            params.push({name: 'comment', value: comment});
        }
        if (upNestImprove) {
            params.push({name: 'upNestImprove', value: upNestImprove});
        }
        if (upNestFeedback) {
            params.push({name: 'upNestFeedback', value: upNestFeedback});
        }

        if (this.props.surveyType == 'AFTER_CALL') {
            const agentsInTouch = this.props.agents
                .filter(agent => checkedAgents[agent.realtorId])
                .map(agent => agent.realtorId);
            for (const realtorId of agentsInTouch) {
                params.push({name: 'agentsInTouch', value: realtorId});
            }
        }
        const concernList = Object.keys(concerns)
            .map(realtorId => {
                return {realtorId, concern: concerns[realtorId]};
            });
        params.push({name: 'concerns', value: JSON.stringify(concernList)});

        this.setState({isLoading: true});

        $.post('submit-client-checkin-survey', params)
            .then(data => {
                if (checkAjax(data)) {
                    this.setState({isFinished: true});
                }
            })
            .fail(defaultAjaxError)
            .always(() => {
                this.setState({isLoading: false});
            });
    }

    submitNegativeExperience(scoreParam, reason, action) {
        const {requestId, isBuyer, surveyType} = this.props;
        const {score} = this.state;

        $.post('submit-client-checkin-survey', {
            requestId,
            buyer: isBuyer,
            surveyType,
            score,
            negativeExperienceReason: reason,
            negativeExperienceAction: action
        });
    }

    showSuggestedAgents() {
        const {requestId, isBuyer} = this.props;
        const url = isBuyer ? 'buyerSuggestedAgents-json' : 'sellerSuggestedAgents-json';

        this.setState({isLoadingSuggestedAgents: true});

        $.get(url, {requestId}).then(data => {
            if (data.suggestedRealtors) {
                this.setState({
                    loadedSuggestedAgents: true,
                    suggestedRealtors: data.suggestedRealtors,
                    suggestedRealtorQuotes: data.suggestedRealtorQuotes,
                    suggestedRealtorEndorsements: data.suggestedRealtorEndorsements
                });
            }
        }).always(() => {
            this.setState({isLoadingSuggestedAgents: false});
        });
    }

    renderAgent(agent) {
        const isChecked = this.state.checkedAgents[agent.realtorId];

        return (
            <li className="answer-item"
                data-checked={this.state.checkedAgents[agent.realtorId]}
                onClick={() => this.setAgentChecked(agent)}>
                <div className="agent">
                    <div className="checkbox">
                        {isChecked
                            ?
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="20" height="20" rx="2" fill="#3889EB"/>
                                <path d="M6 10.6551L8.79791 13L14 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            :
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="19" height="19" rx="2.5" stroke="#C0CEDE" strokeLinejoin="round"/>
                            </svg>
                        }
                    </div>
                    {agent.isNone
                        ?
                        <div className="agent-name">None</div>
                        :
                        <div className="agent-profile text-nowrap-ellipsis">
                            <img className="agent-photo" src={agent.photoUrl} onError={e => replaceImageOnError(e.target, 'img/profile-icon-l.jpg')}/>
                            <div className="agent-name text-nowrap-ellipsis">{agent.name}</div>
                            <div className="agent-brokerage text-nowrap-ellipsis">{agent.brokerage}</div>
                        </div>
                    }
                </div>
            </li>
        );
    }

    renderConcernQuestion(agent) {
        const maxParts = this.state.maxParts;
        const concern = this.state.concerns[agent.realtorId];

        return (
            <div>
                {void(this.partCounter++)}
                <div className="visible-xs part-num">Part {this.partCounter} of {maxParts}</div>
                <div className="question">
                    Did {agent.name} answer you questions and meet your needs?
                    <div className="hidden-xs part-num">Part {this.partCounter} of {maxParts}</div>
                </div>
                <ul className="answers columned">
                    {this.renderRadio(
                        'Yes, things are good.',
                        concern === false,
                        () => this.setConcern(agent, false))}
                    {this.renderRadio(
                        'No, I have some concerns.',
                        concern !== false && concern != null,
                        () => this.setConcern(agent, true))}
                    {concern !== false && concern != null &&
                        <li className="answer-item fill-width">
                            <input
                                className="answer-input"
                                value={typeof concern == 'string' ? concern : ''}
                                placeholder="Help us by explaining your concern..."
                                onInput={e => this.setConcern(agent, e.target.value || true)}/>
                        </li>
                    }
                </ul>
            </div>
        );
    }

    renderRadio(text, isChecked, clickCallback) {
        return (
            <li className="answer-item simple" onClick={clickCallback}>
                <div className="checkbox">
                    {isChecked
                        ?
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#3889EB"/>
                            <circle cx="10" cy="10" r="4" fill="white"/>
                        </svg>
                        :
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z" stroke="#C0CEDE" strokeWidth="2" strokeLinejoin="round"/>
                        </svg>
                    }
                </div>
                {text}
            </li>
        );
    }

    renderAdminContactModal() {
        const {name, photoUrl, email, phone} = this.props.assignedAdmin;

        return (
            <div className="modal nu-modal upnest-modal fade mobile-compact advisor-modal" id="adminContactModal" role="dialog" style="display: none">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title text-center">
                                Connect with your UpNest Advisor
                            </h4>
                        </div>
                        <div className="modal-body text-center">
                            <img src={photoUrl} className="photo"/>
                            <div className="name">{name}</div>
                            <a href={'mailto:' + email} className="email">
                                <i className="icon icon-email"/>
                                {' '}
                                {email}
                            </a>
                            <a href={'tel:' + phone} className="phone">
                                <i className="icon icon-phone-filled"/>
                                {' '}
                                {returnPhoneFormat(phone)}
                            </a>
                        </div>
                        <div className="modal-footer text-center">
                            <div className="text-center">
                                <button type="button" className="btn btn-gray-outline" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderSuggestedAgents() {
        const {
            suggestedRealtors,
            suggestedRealtorQuotes,
            suggestedRealtorEndorsements,
            isLoadingSuggestedAgents,
            loadedSuggestedAgents
        } = this.state;

        if (suggestedRealtors.length > 0 || isLoadingSuggestedAgents) {
            return (
                <div className="suggested-agents-container">
                    {suggestedRealtors.length > 0 &&
                        <SuggestedAgents
                            requestId={this.props.requestId}
                            isBuyer={this.props.isBuyer}
                            realtors={suggestedRealtors}
                            quotes={suggestedRealtorQuotes}
                            endorsements={suggestedRealtorEndorsements}/>
                    }
                    {isLoadingSuggestedAgents &&
                        <div className="loadingSpinner">
                            <img src={global.imageBaseUrl + 'spinner.gif'}/>
                        </div>
                    }
                </div>
            );
        }
        if (loadedSuggestedAgents && suggestedRealtors.length == 0) {
            return (
                <div className="suggested-agents-container">
                    <div className="text-center">
                        Sorry, we were unable to load new agent recommendations.
                    </div>
                </div>
            );
        }
        return null;
    }

    render() {
        const {isBuyer, agents, surveyType} = this.props;
        const {
            isLoading,
            isFinished,
            maxParts,
            score,
            comment,
            checkedAgents,
            concerns,
            upNestImprove,
            upNestFeedback
        } = this.state;
        const selectedAgents = surveyType === 'AFTER_CALL'
            ? agents.filter(agent => checkedAgents[agent.realtorId])
            : agents;
        const hasConcerns = Object.keys(concerns).filter(key => concerns[key]).length > 0;
        const isScoreLow = score >= 1 && score <= 4;
        const isSatisfied = !isScoreLow && !hasConcerns;

        this.partCounter = 0;

        const html = (
            <div className="client-checkin-survey">
                {this.renderAdminContactModal()}

                <div className="survey-header">
                    <div className="container">
                        <h1 className="survey-title">How are things going?</h1>
                        <h4 className="hidden-xs survey-subtitle">We are committed to outstanding customer experience. We appreciate your feedback on your UpNest experience.</h4>
                        <h4 className="visible-xs survey-subtitle">We appreciate your feedback on your UpNest experience.</h4>
                    </div>
                </div>

                <div className="container">
                    {isFinished
                        ?
                        (isSatisfied
                            ?
                            <div className="survey-form thank-you">
                                <svg className="icon" width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M0.599976 26.9999C0.599976 12.2999 12.6 0.599854 27 0.599854C41.7 0.599854 53.4 12.5999 53.4 26.9999C53.4 41.3999 41.4 53.3998 27 53.3998C12.3 53.3998 0.599976 41.6999 0.599976 26.9999ZM5.39998 26.9999C5.39998 38.9999 15 48.8998 27 48.8998C38.7 48.8998 48.6 38.9999 48.6 26.9999C48.6 14.9999 39 5.09985 27 5.09985C15 5.09985 5.39998 14.9999 5.39998 26.9999ZM15.6115 28.5187C16.4268 27.5873 17.7457 27.5873 18.561 28.5187L22.6949 33.2406L35.439 18.6985C36.2543 17.7672 37.5731 17.7672 38.3885 18.6985C39.2038 19.6298 39.2038 21.1362 38.3885 22.0675L24.1761 38.3015C23.3608 39.2328 22.0419 39.2328 21.2266 38.3015L15.6115 31.8877C14.7961 30.9564 14.7961 29.45 15.6115 28.5187Z" fill="#3889EB"/>
                                </svg>
                                <div>
                                    <div className="line-1">Thank you for your feedback!</div>
                                    <div className="line-2">Your survey was submitted.</div>
                                </div>
                            </div>
                            :
                            <div className="survey-form poor-thank-you">
                                <h2 className="ty-title">Thank you for providing your feedback.</h2>
                                <p className="ty-content">
                                    {isScoreLow
                                        ? `We're sorry to hear that you scored your UpNest network agent experience ` +
                                            `${score} out of 10.`
                                        : `We're sorry to hear that you had concerns with your UpNest Network Agent.`
                                    }
                                    <br/>
                                    <br/>
                                    We want to make sure that you have an exceptional experience working with UpNest to
                                    {isBuyer ? 'buy' : 'sell'} your home. Based on your feedback, we have curated a new
                                    list of agents to better suit your needs. If you’d prefer to talk to one of our
                                    UpNest Advisors, they can find you the right agent.
                                </p>
                                <div className="buttons">
                                    <button
                                        type="button"
                                        className="btn primary-button"
                                        onClick={() => {
                                            trackEvent('Survey', 'checkInSurveyShowSuggestedAgents').withGA();
                                            this.showSuggestedAgents();
                                            this.submitNegativeExperience(
                                                score,
                                                isScoreLow ? 'Low score' : 'Has concerns',
                                                'See Other Agents');
                                        }}>
                                        <span className="visible-xs-inline">
                                            See Other Agents
                                        </span>
                                        <span className="hidden-xs">
                                            See New Agent Recommendations
                                        </span>
                                        {' '}
                                        <i className="icon icon-arrow-direct-right"/>
                                    </button>
                                    <button
                                        type="button"
                                        className="btn secondary-button"
                                        data-toggle="modal"
                                        data-target="#adminContactModal"
                                        onClick={() => {
                                            trackEvent('Survey', 'checkInSurveyConnectAdvisor').withGA();
                                            this.submitNegativeExperience(
                                                score,
                                                isScoreLow ? 'Low score' : 'Has concerns',
                                                'Connect with UpNest Advisor');
                                        }}>
                                        Connect with UpNest Advisor
                                    </button>
                                </div>
                            </div>
                        )
                        :
                        <div className="survey-form">
                            {surveyType == 'AFTER_CALL' &&
                                <div>
                                    {void(this.partCounter++)}
                                    <div className="visible-xs part-num">Part {this.partCounter} of {maxParts}</div>
                                    <div className="question">
                                        <span className="question-content">
                                            Do you like the website? What should we add? How was your experience with
                                            our UpNest Advisor? Do you have any questions?
                                            <span className="required"> *Required</span>
                                        </span>
                                        <div className="hidden-xs part-num part-num-top-adjustment">
                                            Part {this.partCounter} of {maxParts}
                                        </div>
                                    </div>
                                    <div className="answers columned">
                                        <div className="answer-item right-indent">
                                            <textarea
                                                className="answer-input answer-input-dimensions"
                                                value={typeof upNestImprove === 'string' ? upNestImprove : ''}
                                                placeholder="Type here..."
                                                onInput={e => this.setState({upNestImprove: e.target.value})}
                                                data-gramm="false"
                                                data-gramm_editor="false"
                                                data-enable-grammarly="false"
                                            />
                                        </div>
                                    </div>
                                    {void(this.partCounter++)}
                                    <div className="visible-xs part-num">Part {this.partCounter} of {maxParts}</div>
                                    <div className="question">
                                        Have any of these agents been in touch with you?
                                        <span className="required"> *Required</span>
                                        <div className="hidden-xs part-num">Part {this.partCounter} of {maxParts}</div>
                                    </div>
                                    <ul className="answers agents">
                                        {agents.map(agent => this.renderAgent(agent))}
                                        {this.renderAgent({realtorId: 0, isNone: true})}
                                    </ul>
                                </div>
                            }
                            {selectedAgents.map(agent => this.renderConcernQuestion(agent))}

                            {surveyType == 'AFTER_INTERVIEW' &&
                                <div>
                                    {void(this.partCounter++)}
                                    <div className="visible-xs part-num">Part {this.partCounter} of {maxParts}</div>
                                    <div className="question">
                                        If you have any other additional comment on your experience so far, please let us know:
                                        <div className="hidden-xs part-num">Part {this.partCounter} of {maxParts}</div>
                                    </div>
                                    <div className="answers columned">
                                        <div className="answer-item fill-width">
                                            <textarea
                                                className="answer-input"
                                                value={typeof comment == 'string' ? comment : ''}
                                                placeholder="Type here..."
                                                onInput={e => this.setState({comment: e.target.value})}
                                                data-gramm="false"
                                                data-gramm_editor="false"
                                                data-enable-grammarly="false"
                                            />
                                        </div>
                                    </div>
                                </div>
                            }

                            {void(this.partCounter++)}
                            <div className="visible-xs part-num">Part {this.partCounter} of {maxParts}</div>
                            <div className="question">
                                How likely are you to recommend UpNest to a friend or colleague?
                                <span className="required"> *Required</span>
                                <div className="hidden-xs part-num">Part {this.partCounter} of {maxParts}</div>
                            </div>

                            <div className="scores">
                                <div className={`score-slider ${!score ? 'no-handle' : ''}`}>
                                    <ul className="score-ticks">
                                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(value => {
                                            return (
                                                <li
                                                    key={value}
                                                    className={'score-' + value + ' ' + (score == value ? 'selected' : '')}
                                                    onClick={() => this.setScore(value)}>
                                                    {value}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                    <RangeSlider
                                        value={score}
                                        min={1}
                                        max={10}
                                        step={1}
                                        onInput={e => this.setScore(e.target.value)}/>
                                </div>
                                <div className="likelies">
                                    <div className="unlikely">Not all likely</div>
                                    <div className="likely">Extreme likely</div>
                                </div>
                            </div>

                            {void(this.partCounter++)}
                            <div className="visible-xs part-num">Part {this.partCounter} of {maxParts}</div>
                            <div className="question"> Any feedback for UpNest?
                                <div className="hidden-xs part-num">
                                    Part {this.partCounter} of {maxParts}
                                </div>
                            </div>
                            <div className="answers columned">
                                <div className="answer-item right-indent">
                                    <textarea
                                        className="answer-input answer-input-dimensions"
                                        value={typeof upNestFeedback === 'string' ? upNestFeedback : ''}
                                        placeholder="Type here..."
                                        onInput={e => this.setState({upNestFeedback: e.target.value})}
                                        data-gramm="false"
                                        data-gramm_editor="false"
                                        data-enable-grammarly="false"
                                    />
                                </div>
                            </div>

                            <hr/>

                            <div className="survey-footer">
                                <button
                                    type="button"
                                    className="btn btn-default submit-button"
                                    disabled={!this.isFormValid}
                                    onClick={this.submit.bind(this)}>
                                    Submit <i className="icon icon-arrow-direct-right"/>
                                </button>
                            </div>
                            {isLoading &&
                                <div className="loadingSpinner" style="display: block">
                                    <img src={global.imageBaseUrl + 'spinner.gif'}/>
                                </div>
                            }
                        </div>
                    }

                    {this.renderSuggestedAgents()}
                </div>
            </div>
        );

        if (this.state.maxParts != this.partCounter) {
            this.setState({maxParts: this.partCounter});
        }

        return html;
    }
}
